export default __webpack_public_path__ + "static/image3-c6b7640661ea108e091f4a8fde758730.jpg";